import React, { useState, useEffect } from "react";

const SpeakRightChallange = ({ setCurrentSlideData, contentId, data }) => {
  const [Text, setText] = useState(data?.text || "");

  // Update  text in state and slide data
  const handleTextChange = (e) => {
    const text = e.target.value;
    setText(text);

    // Update the slide data with the  text
    setCurrentSlideData((currentSlideData) => {
      return {
        ...currentSlideData,
        content: currentSlideData.content.map((contentObj) => {
          if (contentObj.id === contentId) {
            return {
              ...contentObj,
              data: {
                ...contentObj.data,
                text: text,
              },
            };
          } else {
            return contentObj;
          }
        }),
      };
    });
  };

  return (
    <div key={contentId} className="font-sans">
      <h1 className="text-2xl font-bold mb-4">Speak Right Challange</h1>

      {/* Input for  text */}
      <div className="mb-4">
        <label htmlFor="Text" className="block text-lg font-medium mb-2">
          Paragraph for Student to Speak:
        </label>
        <textarea
        key={contentId}
          id="Text"
          value={Text}
          onChange={handleTextChange}
          placeholder="Enter the text you want the student to speak"
          rows="3"
          className="w-full p-2 border border-gray-300 rounded-md"
        />
      </div>
    </div>
  );
};

export default SpeakRightChallange;